import Icon, { IconTypes } from "shared/ui/icon";
import CheckmarkIcon from "shared/ui/icons/CheckmarkIcon";
import { GewoonZeker } from "shared/ui/icons/GewoonZeker";
import { OptionModalState } from "widgets/configurator/option-modal";

const USPS = [
  "Poedercoating en glassschade is verzekerd",
  "Schade aan onderdelen en door ongelukken",
  "Verlenging van de fabrieksgarantie",
];

interface Props {
  setOptionModalState: (state: OptionModalState) => void;
  className?: string;
}
const GewoonzekerBlock = ({ className, setOptionModalState }: Props) => {
  const setGewoonZekerModal = () => {
    setOptionModalState({
      isOpen: true,
      heading: "Wil je extra zekerheid?",
      description: (
        <span>
          Bied jezelf meer zekerheid en neem een uitgebreid{" "}
          <button
            className="gg-cursor-pointer gg-underline hover:gg-text-slate-400"
            onClick={() =>
              window.open("/zekerheidspakket-gewoonzeker", "_blank")
            }
          >
            GewoonZeker
          </button>
          pakket bij jouw product. Hiermee ontvang je 3 of 5 jaar zekerheid op
          het glas en poedercoating. Je kunt GewoonZeker toevoegen aan je
          bestelling bij de volgende stap.
        </span>
      ),
    });
  };
  return (
    <div
      className="gg-relative gg-bg-[#F0F8F1] gg-px-4 gg-py-5 sm:gg-px-7"
      data-testid="warranty-block"
    >
      <div className="gg-space-y-3">
        {/* Zeker icon */}

        <GewoonZeker className="gg-absolute -gg-top-5 gg-right-8 gg-h-[45px] gg-w-[48.1px] 2xl:gg-h-[51.45px] 2xl:gg-w-[55px]" />
        {/* Main title */}
        <div className="gg-flex">
          <h4 className="gg-text-base gg-font-bold gg-leading-[21.6px] sm:gg-text-lg sm:gg-leading-[21.6px]">
            Voeg GewoonZeker toe aan je bestelling
          </h4>

          <button
            type="button"
            aria-label="Meer informatie over GewoonZeker"
            data-testid="warranty-block-info-button"
            onClick={setGewoonZekerModal}
          >
            <Icon
              name={IconTypes.INFO}
              className="gg-ml-0.5 sm:gg-ml-2"
              alt=""
            />
          </button>
        </div>

        {/* Description */}
        <p className="gg-max-w-[280px] gg-text-xs sm:gg-max-w-md sm:gg-text-sm lg:gg-max-w-sm xl:gg-max-w-md">
          Bied jezelf meer zekerheid en neem een uitgebreid GewoonZeker pakket
          bij jouw product. Hiermee ontvang je 3 of 5 jaar zekerheid op het glas
          en poedercoating. Je kunt GewoonZeker toevoegen aan je bestelling bij
          de volgende stap.
        </p>

        {/* Checkmark list */}
        <ul className="gg-grid gg-gap-y-0.5 sm:gg-gap-y-2.5">
          {USPS.map((text, i) => (
            <li
              key={i}
              className="gg-flex gg-items-center gg-gap-x-1.5 gg-text-xs gg-leading-[22.4px] sm:gg-gap-x-2 sm:gg-text-sm"
            >
              <CheckmarkIcon fill="#052C25" />
              <p className="">{text}</p>
            </li>
          ))}
        </ul>

        {/* From price */}
        <p className="gg-pt-2 gg-text-base gg-font-bold gg-leading-[21.6px]">
          vanaf €119,-
        </p>
      </div>
    </div>
  );
};
export default GewoonzekerBlock;
